import classNames from 'classnames';
import { ReactNode } from 'react';

type DirProps = 'ltr' | 'rtl' | 'auto' | 'inherit';
type TextAlignProps = 'start' | 'center' | 'end' | 'justify';

type SegmentProps = {
  id?: string;
  dir?: DirProps;
  color?: string;
  colorWeight?: number;
  borderWeight?: number;
  rounded?: string;
  textAlign?: TextAlignProps;
  bg?: boolean;
  hoverable?: boolean;
  padded?: boolean;
  noPad?: boolean;
  noMargin?: boolean;
  dataTestId?: string;
  children?: ReactNode;
  className?: string;
};

function Segment({
  id,
  dir = 'inherit',
  color = 'gray',
  colorWeight = 300,
  borderWeight = 1,
  rounded = 'md',
  textAlign = 'start',
  hoverable = false,
  bg = false,
  padded = false,
  noPad = false,
  noMargin = false,
  dataTestId,
  children,
  className
}: SegmentProps) {
  return (
    <div
      id={id}
      data-testid={dataTestId}
      dir={dir}
      className={classNames(
        'overflow-y-auto',
        noPad ? 'p-1' : 'p-2 xs:p-3 sm:p-4',
        noMargin ? 'm-1' : 'm-2 sm:m-3 md:m-4',
        { 'sm:p-8': padded },
        'border-2 shadow-sm',
        getBorderClass(borderWeight, color, colorWeight, rounded),
        getTextAlignClass(textAlign),
        getBackgroundClass(bg, hoverable, color),
        className
      )}
    >
      {children}
    </div>
  );
}

function getTextAlignClass(textAlign: TextAlignProps) {
  return `text-${textAlign}`;
}

function getBorderClass(borderWeight: number, color: string, colorWeight: number, rounded: string) {
  const borderClass = borderWeight === 1 ? 'border' : `border-${borderWeight}`;
  const borderColorClass = `border-${color}-${colorWeight}`;
  const roundedClass = `rounded-${rounded}`;
  return `${borderClass} ${borderColorClass} ${roundedClass}`;
}

function getBackgroundClass(bg: boolean, hoverable: boolean, color: string) {
  return bg ? `bg-${color}-50` : hoverable ? `bg-white hover:bg-${color}-50` : 'bg-white';
}

export default Segment;
